import {useCallback, useEffect, useState} from 'react';

import type {Conversation} from '@stripe-internal/conversations-client';
import {ObservabilityProvider as InlineDataObservabilityProvider} from '@stripe-internal/inline-data';
import {
  isMessageInteractivityEnabled,
  useApp,
  useConversationLogEvents,
  useRestartConversationEvents,
} from '@stripe-internal/conversations-assistant';
import {useConversationPoller} from '@stripe-internal/conversations-ui';

import {DotComLog} from './DotComLog';

type Props = {
  conversation: Conversation;
};

export function DotComAssistantLog({conversation}: Props) {
  const app = useApp();
  const [disableMessageInteractivity, setDisableMessageInteractivity] =
    useState<boolean>(!isMessageInteractivityEnabled(conversation));

  useConversationLogEvents(conversation);
  useRestartConversationEvents();
  useConversationPoller(conversation);

  const bindToConversationState = useCallback(() => {
    setDisableMessageInteractivity(
      !isMessageInteractivityEnabled(conversation),
    );
  }, [conversation]);

  useEffect(() => {
    bindToConversationState();
  }, [bindToConversationState]);

  return (
    <InlineDataObservabilityProvider config={{analytics: app.analytics}}>
      <DotComLog
        conversation={conversation}
        animated
        disableInteraction={disableMessageInteractivity}
      />
    </InlineDataObservabilityProvider>
  );
}
